import SliderManager from "../slider/sliderManager";

export default class Step2Manager
{
    initialize() {
        this.lastComplementId = null;
        this.eventDelegation();
    }

    eventDelegation() {
        $('[data-complementcategory]').on('hidden.bs.collapse', (e) => {
            myApp.scrollManager.scrollOn('[data-scrollcontainer]', $(e.currentTarget).data('complementcategory'));
        })
        $('[data-container=room-distribution-xs]').on('hidden.bs.collapse', () => {
            myApp.scrollManager.scrollToElement('[data-header=room-distribution]');
        })
        $('[data-container=room-sold-out-xs]').on('hidden.bs.collapse', () => {
            myApp.scrollManager.scrollToElement('[data-header=room-sold-out]');
        })
        $('[data-change-meal-plan]').on('click', () => {
            $('[name="formulari_pas1"]').submit();
        });

        const infoCholloModal = $("#info_chollo_modal");
        infoCholloModal.on('custom-modal-shown', () => {
            $(".btn-bottom-fixed-xs-full").hide();
        });
        infoCholloModal.on('custom-modal-hidden', () => {
            $(".btn-bottom-fixed-xs-full").show();
        });
    };

    showComplementModal(event) {
        const complementId = $(event.currentTarget).data('complementid');
        const infoComplementModal = $('#info_complement');
        this.scrollToReview = event.scrollToReview;
        if (this.lastComplementId !== complementId) {
            $.ajax({
                type: 'POST',
                url: myApp.config.routing.infoComplement + '/' + complementId,
                data: {
                    idComplement: complementId
                },
                success: (data) => {
                    if (!data) {
                        return;
                    }
                    this.sliderManager = undefined;
                    const infoComplementModalContent = infoComplementModal.find('[data-entity="modal-activities-content"]');
                    infoComplementModalContent.html("");

                    infoComplementModal.find('[data-entity="modal-activities-content"]').append(data);

                    this.infoComplementEvents(infoComplementModal, complementId);

                    myApp.customModalManager.openModal('#info_complement');
                    this.lastComplementId = complementId;
                }
            });
        } else {
            this.infoComplementEvents(infoComplementModal, complementId);
            myApp.customModalManager.openModal('#info_complement');
        }
    };

    getCookie(cname) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    infoComplementEvents(infoComplementModal, complementId) {

        let reviewsContainer = '#info_complement .active-item:visible [data-entity="reviews"]';

        infoComplementModal.one('custom-modal-hide', (event) => {
            $(event.currentTarget).find('.custom-modal-body').scrollTop(0);
        });

        infoComplementModal.one('custom-modal-shown',  ()=>  {
            let activeComplement = infoComplementModal.find('.active-item')

            if (this.sliderManager === undefined) {
                this.sliderManager = new SliderManager();
                if (this.scrollToReview && $(reviewsContainer).length > 0){
                    let complementGalery = activeComplement.find('[data-gallery]:visible').data('gallery');

                    if( complementGalery ) {
                        this.sliderManager.addSlider('[data-gallery="activity-'+complementId+'"]', () => {
                            myApp.scrollManager.scrollContainerToElement(
                                '#info_complement .custom-modal-body',
                                reviewsContainer
                            );
                        });
                    } else {
                        myApp.scrollManager.scrollContainerToElement(
                            '#info_complement .custom-modal-body',
                            reviewsContainer
                        );
                    }
                } else {
                    this.sliderManager.addSlider('[data-gallery="activity-'+complementId+'"]');
                }
            } else if (this.scrollToReview && $(reviewsContainer).length > 0) {
                myApp.scrollManager.scrollContainerToElement(
                    '#info_complement .custom-modal-body',
                    '#info_complement .active-item:visible [data-entity="reviews"]'
                );
            }
        });

        $('[data-action="scroll-to-activity-reviews"]').one('click', () => {
            if ($(reviewsContainer).find('user-review').length > 0) {
                myApp.scrollManager.scrollContainerToElement(
                    '#info_complement .custom-modal-body',
                    reviewsContainer
                );
            }
        });
    }
};
